var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 146,
    viewBox: "0 0 176 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.52 77.8501C155.52 103.61 147.01 124.5 136.52 124.5C135.6 124.5 131.21 124.8 130.33 124.5C121.12 121.28 117.52 101.36 117.52 77.8501C117.52 53.7601 120.7 33.6801 130.24 31.2001C130.9 31.0201 135.84 31.2001 136.52 31.2001C147 31.1801 155.52 52.0801 155.52 77.8501Z",
    fill: "#008FFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.52 77.8501C155.52 103.61 147.01 124.5 136.52 124.5C135.6 124.5 131.21 124.8 130.33 124.5C121.12 121.28 117.52 101.36 117.52 77.8501C117.52 53.7601 120.7 33.6801 130.24 31.2001C130.9 31.0201 135.84 31.2001 136.52 31.2001C147 31.1801 155.52 52.0801 155.52 77.8501Z",
    fill: "url(#paint0_linear_602_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.13 124.49C141.623 124.49 150.13 103.604 150.13 77.8399C150.13 52.0759 141.623 31.1899 131.13 31.1899C120.636 31.1899 112.13 52.0759 112.13 77.8399C112.13 103.604 120.636 124.49 131.13 124.49Z",
    fill: "#008FFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.21 115.68C138.715 115.68 145.61 98.7519 145.61 77.8701C145.61 56.9882 138.715 40.0601 130.21 40.0601C121.705 40.0601 114.81 56.9882 114.81 77.8701C114.81 98.7519 121.705 115.68 130.21 115.68Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.21 105.46C136.418 105.46 141.45 93.1076 141.45 77.87C141.45 62.6325 136.418 50.28 130.21 50.28C124.003 50.28 118.97 62.6325 118.97 77.87C118.97 93.1076 124.003 105.46 130.21 105.46Z",
    fill: "#008FFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.21 96.1901C134.33 96.1901 137.67 87.9879 137.67 77.8701C137.67 67.7522 134.33 59.55 130.21 59.55C126.09 59.55 122.75 67.7522 122.75 77.8701C122.75 87.9879 126.09 96.1901 130.21 96.1901Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.21 87.46C132.364 87.46 134.11 83.1664 134.11 77.87C134.11 72.5736 132.364 68.28 130.21 68.28C128.056 68.28 126.31 72.5736 126.31 77.87C126.31 83.1664 128.056 87.46 130.21 87.46Z",
    fill: "#008FFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M112.76 89.8201L119.3 84.5601V87.1901L132.19 77.8401L117.31 80.1601L119.36 81.8101L112.41 85.8601L112.76 89.8201Z",
    fill: "url(#paint1_linear_602_2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1699 69.6699H33.8399L42.1299 75.9399H126.75L128.86 79.0799H42.5899L35.6799 87.4599H25.3099L30.1499 80.6899V77.9699L23.1699 69.6699Z",
    fill: "#008FFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4001 77.5701H41.0701H42.5801H127.2L128.86 79.0801H42.5901L35.6801 87.4601H25.3101L30.1501 80.6901V77.9701L30.4001 77.5701Z",
    fill: "url(#paint2_linear_602_2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.86 75.9399L120.67 72.6599L132.19 77.8399L120.52 82.4799L122.75 77.8699L122.86 75.9399Z",
    fill: "#008FFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.86 75.9399L120.67 72.6599L132.19 77.8399L120.52 82.4799L122.75 77.8699L122.86 75.9399Z",
    fill: "url(#paint3_linear_602_2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.19 77.8401L122.75 77.8701L120.52 82.4801L132.19 77.8401Z",
    fill: "url(#paint4_linear_602_2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0499 76.6699H42.1299L33.8399 69.6699H23.1699L29.0499 76.6699Z",
    fill: "url(#paint5_linear_602_2)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3701 106.99L71.5501 109.51C72.2898 109.717 73.0725 109.712 73.8095 109.496C74.5465 109.28 75.2084 108.863 75.7201 108.29C80.1301 104.73 84.6601 101.03 87.3401 96.04L76.0001 97.12C72.7101 97.44 69.7301 100.98 66.8501 102.56C64.9824 103.582 63.0481 104.478 61.0601 105.24C59.6701 105.77 56.8801 107.23 55.3701 106.99Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5101 55.2701C38.5552 55.1656 38.6322 55.0781 38.7301 55.0201C38.838 54.9897 38.9521 54.9897 39.0601 55.0201C40.9001 55.2601 42.7367 55.5301 44.5701 55.8301C43.9308 56.7768 43.6868 57.9359 43.8901 59.0601C44.1083 60.1755 44.6673 61.1958 45.4901 61.9801C45.0607 61.9686 44.6357 61.891 44.2301 61.7501L41.0001 60.8101C40.3201 60.6101 39.1701 60.4901 38.7701 59.8101C38.5284 59.1881 38.3768 58.5349 38.3201 57.8701C38.0704 57.0086 38.1378 56.0861 38.5101 55.2701V55.2701Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8599 87.4601L37.2299 79.2701L42.5899 79.0801L35.5999 87.4601H31.8599Z",
    fill: "url(#paint6_linear_602_2)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3101 87.4601L31.1901 79.2501L36.0401 79.0801L29.0401 87.4601H25.3101Z",
    fill: "url(#paint7_linear_602_2)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9302 69.6699L34.3902 76.6699H38.3102L30.6602 69.6699H26.9302Z",
    fill: "url(#paint8_linear_602_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_602_2",
    x1: 194.45,
    y1: 69.1401,
    x2: -21.76,
    y2: 100.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_602_2",
    x1: 107.88,
    y1: 73.5401,
    x2: 171.98,
    y2: 118.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_602_2",
    x1: 78.8101,
    y1: 54.6101,
    x2: 74.1101,
    y2: 132.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_602_2",
    x1: 109.54,
    y1: 68.3099,
    x2: 178.39,
    y2: 116.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_602_2",
    x1: 114.34,
    y1: 61.5301,
    x2: 155.81,
    y2: 125.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_602_2",
    x1: 42.4899,
    y1: 84.3799,
    x2: 22.9299,
    y2: 62.5299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_602_2",
    x1: 39.4599,
    y1: 66.4801,
    x2: 34.0099,
    y2: 107.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_602_2",
    x1: 32.9101,
    y1: 66.4801,
    x2: 27.4601,
    y2: 107.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_602_2",
    x1: 34.5602,
    y1: 87.4199,
    x2: 29.8302,
    y2: 51.8299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f45444ec6fda8943a2d7722c90df3a24.svg";
export { ForwardRef as ReactComponent };